import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { InfoDialogComponent } from '../dialogs/info-dialog/info-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PopupHelper } from '../../helpers/pop-up-helper';
import { SubmitDialogComponent } from '../dialogs/submit-dialog/submit-dialog.component';
import { Bundle } from 'src/app/models/bundle.model';
import { BundleService } from 'src/app/services/bundle.service';

@Component({
  selector: 'app-bundle',
  templateUrl: './bundle.component.html',
  styleUrls: ['./bundle.component.scss']
})
export class BundleComponent implements OnInit {
  createBundleForm: UntypedFormGroup;
  areBundlesLoaded = false;
  bundleCreating = false;  
  dataSource = new MatTableDataSource<Bundle>();
  languages = ['DE', 'EN'];

  bundleColumns = [
    {
      columnDef: 'bundleID',
      header: 'BundleID',
      cell: (element: Bundle) => `${element.bundleID}`,
    },
    {
      columnDef: 'bundleName',
      header: 'Bundle Name',
      cell: (element: Bundle) => `${element.bundleName}`,
    },
    {
      columnDef: 'language',
      header: 'Language',
      cell: (element: Bundle) => `${element.language}`,
    },
    {
      columnDef: 'actions',
      header: '',
      cell: (element: Bundle) => `${element}`,
    },
  ]

  displayedColumnsBundles = this.bundleColumns.map(c => c.columnDef);

  constructor(
    private bundleService: BundleService,
    private dialog: MatDialog,
    private popUp: MatSnackBar,
    private popUpHelper: PopupHelper,
  ) {
    this.refreshBundles();
  }

  refreshBundles() {
    this.bundleService.getBundles().subscribe(
      (data) => {
        this.dataSource.data = data;
        this.areBundlesLoaded = true;
      },
      (error) => {
        this.popUpHelper.showErrorPopUp("There was an error with getting the bundles!\n", error)
      }
    )
  }

  createBundle() {
    this.bundleCreating = true;
    let bundle = new Bundle();

    bundle.bundleID = this.createBundleForm.get('bundleID').value;
    bundle.bundleName = this.createBundleForm.get('bundleName').value;
    bundle.language = this.createBundleForm.get('language').value;

    this.bundleService.createBundle(bundle).subscribe(
      (data) => {
        this.bundleCreating = false;
        this.refreshBundles();
        this.popUpHelper.showPopUp('Bundle was created!');
      },
      (error) => {
        this.bundleCreating = false;
        this.refreshBundles();
        this.showErrorMessage("There was an error with creating the bundle: \n" + error.error);
      }
    )
  }

  deleteBundle(bundleToDelete: Bundle) {
    const dialogRef = this.openSubmitDialog(
      'Confirm Bundle deletion',
      'Bundle with name "' + bundleToDelete.bundleName + '" is going to be deleted. Are you sure?');
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.popUpHelper.showLoadingPopUp("Bundle is deleting!")
        this.bundleService.deleteBundle(bundleToDelete).subscribe(
          (data) => {
            this.refreshBundles();
            this.popUpHelper.showPopUp('Bundle was deleted!');
          },
          (error) => {
            this.refreshBundles();
            this.popUp.dismiss();
            this.showErrorMessage("There was an error with deleting the bundle, it is possible that bundle is assigned to Course, please check if it is so. In case it isn't, please contact Administrator");
          }
        )
      }
    });
  }

  ngOnInit(): void {
    this.createBundleForm = new UntypedFormGroup({
      bundleID: new UntypedFormControl('',  [Validators.required, Validators.pattern('^[a-zA-Z0-9\\-]*[a-zA-Z0-9]$') ]),
      bundleName: new UntypedFormControl('',  [Validators.required]),
      language: new UntypedFormControl('',  [Validators.required] ),
    });
  }

  errorHandling(control: string, error: string) {  
    return this.createBundleForm.controls[control].hasError(error);
  }

  showErrorMessage(message: string) {
    this.dialog.open(InfoDialogComponent, {
      width: '450px',
      data: { "title" : "Error", "message": message},
    });
  }

  private openSubmitDialog(title: string, message: string): MatDialogRef<SubmitDialogComponent, any> {
    return this.dialog.open(SubmitDialogComponent, {
        width: '450px',
        data: { title, message }
    });
  }
}
